<template>
  <div class="shop-coin-discount-sector bg-white p-2" :style="{
    borderTop: '1px dashed #bdbdbd',
  }">
    <div class="flex gap-2 justify-between items-center">
      <div>
        <span class="text-base">{{ $t("您有購物金") }}</span>
      </div>
      <div class="flex flex-col items-end">
        <span class="text-accent font-weight-bolder text-2xl">
          {{ currencyFormat(data.account_shop_coin || 0) }}
        </span>
        <span class="text-gray-400 text-xs">
          {{
            `(${$t("shopCoins.maxCoins", coinDiscountLimit, [
              currencyFormat(coinDiscountLimit || 0),
            ])})`
          }}
        </span>
      </div>
    </div>
    <div class="flex gap-2 justify-between items-end mt-1">
      <div class="flex-none">
        <span class="text-lg text-gray-600">{{ $t("本次使用") }}</span>
      </div>
      <div class="flex-1 flex">
        <el-form-item class="flex-1 mb-0" prop="shop_coin_discount" :rules="[
          {
            type: 'number',
            min: 0,
            max: coinDiscountLimit,
            message: `（請輸入 0-${coinDiscountLimit}）`,
          },
        ]">
          <el-input-number v-model="form.shop_coin_discount" class="el-input-shop-coin-discount" :step="100" :min="0"
            :max="coinDiscountLimit" size="large" @clear="clearCoinDiscount()" aria-label="輸入本次使用的購物金" clearable />
        </el-form-item>
        <div class="flex-none">
          <el-button type="primary" size="large" :disabled="!coinDiscountLimit" @click="setAllCoinDiscount()"
            aria-label="使用全部購物金">
            {{ $t("shopCoins.useAllCoin") }}
          </el-button>
        </div>
      </div>
    </div>
    <p class="hint text-right">
      {{ $t("shopCoins.useHint") }}
    </p>
  </div>
</template>

<script setup>
import { currencyFormat } from "../../../utils";
import { useVModel } from "@vueuse/core";

const props = defineProps({
  modelValue: Object,
  data: Object,
  coinDiscountLimit: Number,
});
const emit = defineEmits(["update:modelValue"]);

const form = useVModel(props, "modelValue", emit);

const setAllCoinDiscount = () => {
  form.value.shop_coin_discount = props.coinDiscountLimit;
};

const clearCoinDiscount = () => {
  form.value.shop_coin_discount = 0;
};
</script>
<style lang="scss">
.shop-coin-discount-sector {
  .el-input-shop-coin-discount {
    max-width: 200px;
  }

  .hint {
    font-size: 12px;
    color: var(--el-text-color-secondary)
  }
}
</style>